<app-dialog
  [title]="data.title"
  [description]="data.description"
  [actions]="actions"
  (action)="action($event)"
  (close)="close()"
>
 <div class="update-qty">
  <div class="input-container pt-3" *ngIf="!data.isDraftShipment">
    <label for="" class="input-container_label">{{ data.inputLabel }}</label>
    <input
      type="number"
      class="input-container_input"
      (input)="inputChange($event)"
      [max]="data.maxQty"
      [min]="data.minQty || 1"
      [formControl]="qtyInput"
    />
    <p *ngIf="data?.status!=='DRAFT' && data.isShowAlert" class="warning-forcast mt-2"><i class="fal fa-exclamation-triangle me-2"></i> Amazon will not allow you to update more than 5% 6 pieces
    </p>
  </div>
</div>

<div class="select-box pt-5 px-3 pb-4 mb-2"  *ngIf="data.isDraftShipment">
  <button class="select-box-btn" (click)="onChange(true)" [ngClass]="{'active': draftAction == 'Keep Draft'}"><span></span>Keep this draft</button>
  <button class="select-box-btn" (click)="onChange(false)" [ngClass]="{'active': draftAction == 'Delete Draft'}"><span></span>Delete this draft</button>
  
 </div> 
</app-dialog>
